import { render, staticRenderFns } from "./PhoneNumberList.vue?vue&type=template&id=06fb0336&scoped=true"
import script from "./PhoneNumberList.vue?vue&type=script&lang=js"
export * from "./PhoneNumberList.vue?vue&type=script&lang=js"
import style0 from "./PhoneNumberList.vue?vue&type=style&index=0&id=06fb0336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fb0336",
  null
  
)

export default component.exports